module.exports = __webpack_public_path__ + "static/media/Poker Tournament2022.e0db2293.jpg";